/**
 * Flux DC App Configuration
 *
 * Defines app identity and section navigation for the Data Center domain.
 */

import { vortxColors } from '@vortx/shared-ui';

export const appConfig = {
  appKey: 'flux_dc',
  appName: 'Flux DC',
  appPath: '/dc',
  primaryColor: vortxColors.gold,
  icon: 'Memory',

  sections: [
    { key: 'site', label: 'Site', icon: 'LocationOn' },
    { key: 'it_load', label: 'IT Load', icon: 'Memory' },
    { key: 'infrastructure', label: 'Infrastructure', icon: 'BuildCircle' },
    { key: 'interconnection', label: 'Interconnection', icon: 'ElectricalServices' },
    { key: 'tariff', label: 'Tariff', icon: 'Receipt' },
    { key: 'financial', label: 'Financial', icon: 'AccountBalance' },
  ],

  features: {
    enableUL3141: true,
  },

  get apiBasePath() {
    return `/api/${this.appKey}/v1`;
  },
};

export default appConfig;
